import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FaHome,
  FaUserAlt,
  FaCalendarAlt,
  FaChartLine,
  FaEnvelope,
  FaTooth,
  FaFlask,
  FaBell,
} from 'react-icons/fa';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const { user } = useAuth();
  
  const navItems = [
    { name: 'Dashboard', icon: <FaHome className="h-5 w-5" />, path: '/dentist/dashboard' },
    { name: 'Patients', icon: <FaUserAlt className="h-5 w-5" />, path: '/dentist/patients' },
    { name: 'Calendar', icon: <FaCalendarAlt className="h-5 w-5" />, path: '/dentist/calendar' },
    { name: 'Analytics', icon: <FaChartLine className="h-5 w-5" />, path: '/dentist/analytics' },
    { name: 'Notifications', icon: <FaBell className="h-5 w-5" />, path: '/dentist/notifications' },
    { name: 'Messages', icon: <FaEnvelope className="h-5 w-5" />, path: '/dentist/messages' },
    { name: 'Lab', icon: <FaFlask className="h-5 w-5" />, path: '/dentist/lab' },
  ];

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`fixed md:relative z-20 h-full transition-all duration-300 ease-in-out ${isOpen ? 'translate-x-0 w-64' : '-translate-x-full md:translate-x-0 w-20'} bg-white shadow-lg flex flex-col`}
      >
        <div className="p-4 flex items-center justify-center">
          {isOpen && (
          <Link to="/">
                    <img 
                      src="/imgs/odenta-logo2.jpg"
                      alt="ODenta Logo"
                      className="h-[60px] w-auto"  // Adjust size as needed
                    />
            </Link>
          )}
        </div>

        <nav className="flex-1 px-2 py-4 overflow-y-auto">
          <ul className="space-y-2">
            {navItems.map((item) => (
              <li key={item.name}>
                <Link
                  to={item.path}
                  className="flex items-center p-3 text-[#333333] hover:text-[#0077B6] hover:bg-[rgba(0,119,182,0.05)] rounded-lg transition-colors group"
                  onClick={() => window.innerWidth < 768 && setIsOpen(false)}
                >
                  <span className="text-[#333333] group-hover:text-[#0077B6]">
                    {item.icon}
                  </span>
                  {isOpen && <span className="ml-3">{item.name}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-[rgba(0,119,182,0.1)]">
          <Link to="/profile" className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-[rgba(0,119,182,0.1)] flex items-center justify-center text-[#0077B6]">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            {isOpen && (
              <div className="ml-3">
                <p className="text-sm font-medium text-[#333333]">{user?.name || 'Dentist'}</p>
                <p className="text-xs text-[#333333] opacity-70">Dentist</p>
              </div>
            )}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Sidebar;